<template>
    <card-expandable
        v-if="props.chat.tags.length > 0"
        toggle-color="gray-100"
        is-opened-at-start
        with-collapse-arrow
        with-content
    >
        <text-decorator :size="Size.xs">
            Labels
        </text-decorator>

        <template #content>
            <flex-container
                direction="column"
                align-items="flex-start"
                :gap="Size.xs"
            >
                <chip-label
                    v-for="tag in props.chat.tags"
                    :key="tag.id"
                    background-color="gray-100"
                    border-color="gray-300"
                >
                    <span
                        class="chat-tags-expandable-card__tag-dot"
                        :style="{
                            backgroundColor: tag.color,
                        }"
                    />
                    <text-decorator :size="FontSize.xxs">
                        {{ tag.tag }}
                    </text-decorator>
                </chip-label>
            </flex-container>
        </template>
    </card-expandable>
</template>

<script setup lang="ts">
    import { FontSize, Size } from '@keyvue/one-ui';
    import type { Chat } from '@keyvue/one-api-client';

    const props = defineProps<{ chat: Chat }>();
</script>

<style lang="scss" scoped>
    .chat-tags-expandable-card {
        &__tag-dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
        }
    }
</style>
